import { useContext, useState, useEffect } from "react";
import { Redirect } from 'react-router-dom';
import { useForm } from "react-hook-form";
import './authentication.css';
import { useQuery } from 'react-query';
import * as Api from '../../api/Api';
import * as KeyNames from '../../api/KeyNames';
import { ErrorConnection } from '../../Components/Error/Error';
import { Loading } from '../../Components/Loading/Loading';
import { FeedbackContext } from "../../Components/Context/FeedbackContext";
import BackButton from "../../Components/Buttons/BackButton"

export function ChangePassword({ resetToken }) {
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    const [changedData, setChangedData] = useState(null);

    const { register, handleSubmit, formState: { errors }, getValues, setError } = useForm();

    const onSubmit = data => {
        setChangedData({ ...data, resetToken: resetToken });
    }

    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionData, changedData ? changedData.resetToken : ""],
        async () => await Api.postChangePassword(
            {
                newPassword: changedData.password,
                resetToken: changedData.resetToken
            }
        ),
        { enabled: Boolean(changedData) }
    );


    useEffect(() => {
        if (data) {

            if (data.success) {
                localStorage.setItem(KeyNames.SessionReset, "");//borra disco
                setFeedbackContext({ ...feedbackContext, showMessage: true, idMessage: 101 });

            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
        }

    }, [data]);

    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)


    if (data) {
        if (data.success) {
            return (<Redirect to='/auth/login' />)
        }
    }
    return (
        <form onSubmit={handleSubmit(onSubmit)}
            className='form w-100'
            id='kt_login_signin_form'
        >
            <div className='fv-row mb-10'>

                <div className='fv-row mb-10'>
                    <label className='form-label fs-6 fw-bolder text-dark'>Contraseña</label>

                    <input {...register("password", {
                        required: true,
                        minLength: {
                            value: 8,
                            message: "La contraseña debe tener al menos 8 caracteres."
                        }
                    })}

                        className='form-control form-control-lg form-control-solid'
                        type='password'
                        autoComplete='off'
                    />
                    <>{errors.password && <span className="text-danger">Ingresar nueva contraseña</span>}</>
                    <div className="text-muted">Utilice 8 o más caracteres con una combinación de letras y números (sensible a mayúsculas/minúsculas).</div>
                </div>
                <div className='fv-row mb-10'>
                    <label className='form-label fs-6 fw-bolder text-dark'>Confirme Contraseña</label>
                    <input {...register("confirmPassword", {
                        required: true,
                        validate: value => value === getValues('password') && setError("confirmPassword", { message: "Las contraseñas no coinciden." })
                    })}
                        className='form-control form-control-lg form-control-solid'
                        type='password'
                        autoComplete='off'

                    />
                    <>{errors.confirmPassword && <span className="text-danger">Las contraseñas deben coincidir</span>}</>
                </div>

                <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
                    <button
                        type='submit'
                        id='kt_sign_in_submit'
                        className='btn btn-lg btn-primary fw-bolder me-4'

                    >
                        <span className='indicator-label'>Enviar</span>
                    </button>

                    <BackButton />

                </div> </div>
        </form>
    )
}
